export enum NuiFieldClassName {
  BaseWithHiddenLabelModifier = "nui-field--label-hidden",
}

export enum NuiGridColumnClassName {
  BaseWithRowModifier = "nui-grid_col--row",
}
